import api from '../../config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import { LegacyUser } from 'src/interfaces/api/User';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import userImage from '../../images/user.png';
import useAuth from './useAuth';

type User = LegacyUser & {
  newCrmId?: string;
  typeUser: Omit<LegacyEmployee, 'user'>;
};

const useLegacyUser = () => {
  const { fetch } = useAuth();

  const getMe = async (): Promise<{
    id: number;
    username?: string;
    firstname?: string;
    lastname?: string;
    profileImage?: string;
  }> => {
    const { endpoint, ...options } = api.employee.getLegacyCurrentUser();

    const response = await fetch(endpoint, options);

    try {
      const data = await getJsonResponse<{ data: { user: User } }>(response);

      if (!data.data.user) {
        throw new Error('Employé introuvable');
      }

      return {
        id: data.data.user.id,
        username: data.data.user.username,
        firstname: data.data.user.typeUser.firstname,
        lastname: data.data.user.typeUser.lastname,
        profileImage: data.data.user.typeUser.profileImage ? '/' + data.data.user.typeUser.profileImage : userImage,
      };
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const get = async (id: number): Promise<User> => {
    const { endpoint, ...options } = api.employee.getLegacyUser(id);

    const response = await fetch(endpoint, options);

    try {
      const data = await getJsonResponse<{ data: { user: User } }>(response);

      if (!data.data.user) {
        throw new Error('Employé introuvable');
      }

      let newCrmId;
      try {
        newCrmId = await getNewCrmEmployeeId(data.data.user.id);
      } catch (e) {}

      return { ...data.data.user, newCrmId };
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getNewCrmEmployeeId = async (legacyId: number): Promise<string> => {
    const { endpoint, ...options } = api.employee.getNewCrmEmployeeId(legacyId);

    const response = await fetch(endpoint, options);

    try {
      const newCrmIdObject = await getJsonResponse<{ id: string }>(response);

      return newCrmIdObject.id;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { get, getMe };
};

export default useLegacyUser;
